import listedkitService from 'resources/listedkit/listedkit.service';
import milestoneService from 'resources/milestone/milestone.service';
import { extendMilestonesWithTasks } from 'resources/milestone/milestone.operations';


export const getKitMilestonesWithTasks = async (kitId) => {
  if (!kitId) return null;

  const kit = await listedkitService.findById(kitId);

  const milestones = await Promise.all(
    kit.milestone_ids.map(async (milestoneId) => milestoneService.findById(milestoneId))
  );

  const milestonesWithTasks = await extendMilestonesWithTasks(milestones);
  return milestonesWithTasks;
};
